import {
    GET_DISPOSITION_CHOICE,
    SET_DISPOSITION_CHOICE,
    GET_DISPOSITION_SUB_CHOICE,
    SET_DISPOSITION_SUB_CHOICE
} from "./DispositionChoiceType"

const getDispositionChoice = (isLeased?: any) => ({
    type: GET_DISPOSITION_CHOICE,
    isLeased
});

const setDispositionChoice = (choiceList: any) => ({
    type: SET_DISPOSITION_CHOICE,
    choiceList: choiceList
});

const getDispositionSubChoice = (dispositionTypeId: any) => ({
    type: GET_DISPOSITION_SUB_CHOICE,
    dispositionTypeId
});

const setDispositionSubChoice = (subChoiceList: any) => ({
    type: SET_DISPOSITION_SUB_CHOICE,
    subChoiceList: subChoiceList
});

export {
    getDispositionChoice,
    setDispositionChoice,
    getDispositionSubChoice,
    setDispositionSubChoice
}
